import { Injectable, inject } from '@angular/core';
import { CONNECT_DOMAIN } from '../app.token';

/**
 * service to handle CRUD operations on objects in local storage
 */
@Injectable( {
    providedIn: 'root'
} )
export class LocalStorageService {
    /**
     * appId constant, which is read from environment
     */
    #connectDomain = inject( CONNECT_DOMAIN );
    appID = `scope.${this.#connectDomain}`;

    /**
     * save JSON object as string with suffix identifier
     * @param suffix    name of the item in storage
     * @param obj       object with key: value pairs
     */
    save( suffix: string, obj: any ) {
        const KEY = this.appID + '.' + suffix;
        const serialized = JSON.stringify( obj );
        localStorage.setItem( KEY, serialized );
    }

    /**
     * delete given item by suffix identifier
     * @param suffix    name of the item in storage
     */
    delete( suffix: string ) {
        const KEY = this.appID + '.' + suffix;
        localStorage.removeItem( KEY );
    }

    /**
     * clear storage by removing all items
     */
    clear() {
        localStorage.clear();
    }

    /**
     * load given item by suffix identifier
     * @param suffix    name of the item in storage
     * @returns JSON object
     */
    load( suffix: string ) {
        const KEY = this.appID + '.' + suffix;
        const serialized = localStorage.getItem( KEY );
        return typeof serialized === 'string' ? JSON.parse( serialized ) : serialized;
    }

    /**
     * helper function to check if key is in storage
     * @param suffix    name of the item in storage
     * @returns boolean
     */
    hasKey( suffix: string ) {
        const KEY = this.appID + '.' + suffix;
        const keyFound = localStorage.getItem( KEY ) !== null;
        return keyFound;
    }

    /**
     * helper function to add key: value pairs to item
     * @param {string} suffix - name of the item in storage
     * @param {object} obj - object with key: value pairs
     */
    setItem( suffix: string, obj: any ) {
        const KEY = this.appID + '.' + suffix;
        const storageItem = localStorage.getItem( KEY );

        if ( storageItem ) {
            const serialized = JSON.parse( storageItem );
            Object.assign( serialized, obj );
            this.save( suffix, serialized );
        }
    }
}
